import { ChangeDetectionStrategy, Component, computed, DestroyRef, inject, LOCALE_ID, signal } from '@angular/core';
import { FilterItemSearch } from '../../../../../shared/ui/shared-filters/filter-item-search/filter-item-search';
import { FilterDateComponent } from '../../../../../shared/ui/shared-filters/filter-date-component/filter-date-component';
import { FilterSortingComponent } from '../../../../../shared/ui/shared-filters/filter-sorting-component/filter-sorting-component';
import { SubmitButton } from '../../../../../shared/ui/Buttons/submit-button/submit-button';
import { Loading } from '../../../../../utils/loading/loading';
import { Error } from '../../../../public-user-component/auth/shared/error/error';
import { Tables } from '../../../../../shared/ui/shared-tables/tables/tables';
import { Pagination } from '../../../../../shared/ui/shared-tables/pagination/pagination';
import { ConfirmationDialog } from '../../../../../shared/ui/confirmation-dialog/confirmation-dialog';
import { SuccessfulNotification } from '../../../../../utils/successful-notification/successful-notification';
import { ActivatedRoute, Router } from '@angular/router';
import { CityService } from '../../../../../services/city/city.service';
import { finalize } from 'rxjs';
@Component({
  selector: 'app-cities-list-component',
  imports: [
    FilterItemSearch,
    FilterDateComponent,
    FilterSortingComponent,
    SubmitButton,
    Loading,
    Error,
    Tables,
    Pagination,
    ConfirmationDialog,
    SuccessfulNotification,
  ],
  templateUrl: './cities-list-component.html',
  styleUrl: './cities-list-component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CitiesListComponent {
  private locale = inject(LOCALE_ID);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  private destroyRef = inject(DestroyRef);
  private cityService = inject(CityService);
  governorateId = signal('');
  ngOnInit() {
    this.governorateId.set(this.route.snapshot.paramMap.get('id') ?? '');
    this.loadCities();
  }
  showSuccessNotification = signal(false);
  deleteErrorMessage = signal('');
  fromDateLabel = $localize`:@@adminCategoriesCreatedOnFrom:Created On (From)`;
  toDateLabel = $localize`:@@adminCategoriesCreatedOnTo:Created On (To)`;
  lastUpdatedOnFromLabel = $localize`:@@rejectionReasonLastUpdatedOnFrom:Last Updated On (From)`;
  lastUpdatedOnToLabel = $localize`:@@rejectionReasonLastUpdatedOnTo:Last Updated On (To)`;
  reasonNameLabel = $localize`:@@searchCities:Search Cities`;
  reasonNamePlaceholder = $localize`:@@searchCitiesPlaceholder:Search by city title...`;

  // deleteTitle = $localize`:@@deleteRejectionReasonTitle:Delete Rejection Reason`;
  // deleteDescription = $localize`:@@deleteRejectionReasonDescription:Are you sure you want to delete this rejection reason?`;
  confirmButton = signal($localize`:@@delete:Delete`);
  // Loading = $localize`:@@loading:Loading...`;
  // cancelButton = $localize`:@@cancelBtn:Cancel`;
  //deleteSuccessMessage = $localize`:@@deleteRejectionReasonSuccess:Rejection reason deleted successfully`;
  showDeleteDialog = signal(false);
  selectedReasonId = signal<number | null>(null);
  selectedReasonTitle = signal('');
  onCancelDelete() {
    this.showDeleteDialog.set(false);
    this.deleteErrorMessage.set('');
  }
  onOrderByChange(value: string) {
    this.orderBy.set(value as 'TITLE' | 'CREATION_DATE' | 'LAST_MODIFICATION_DATE');

    this.currentPage.set(1);
    this.loadCities();
  }
  onConfirmDelete() {
    // const reasonId = this.selectedReasonId();
    // if (reasonId === null) {
    //   return;
    // }
    // this.confirmButton.set(this.Loading);
    // this.cityService.deleteRejectionReason(reasonId).subscribe({
    //   next: () => {
    //     this.confirmButton.set($localize`:@@delete:Delete`);
    //     this.rows.update((rows) =>
    //       rows
    //         .filter((row) => row['id'] !== reasonId)
    //         .map((row, index) => ({
    //           ...row,
    //           rowNumber: index + 1,
    //         })),
    //     );
    //     this.totalItems.update((total) => Math.max(0, total - 1));
    //     this.totalItems.update((total) => Math.max(0, total - 1));
    //     this.showDeleteDialog.set(false);
    //     this.deleteErrorMessage.set('');
    //     this.showSuccessNotification.set(true);
    //     setTimeout(() => {
    //       this.showSuccessNotification.set(false);
    //     }, 3000);
    //   },
    //   error: (error: any) => {
    //     this.confirmButton.set($localize`:@@delete:Delete`);
    //     const errorCode = error.error?.code;
    //     if (errorCode === 'ORDER_REASON-0003') {
    //       const message = this.isArabic()
    //         ? 'لا يمكن حذف هذا السبب لأنه مستخدم حالياً داخل النظام. للحفاظ على سلامة البيانات، لا يمكن حذف الأسباب المرتبطة بسجلات موجودة'
    //         : 'This reason cannot be deleted because it is currently in use within the system. To maintain data integrity, reasons that are associated with existing records cannot be removed.';
    //       this.deleteErrorMessage.set(message);
    //     }
    //   },
    // });
  }
  deleteSuccessMessage = computed(() => {
    const reasonTitle = this.selectedReasonTitle();

    if (!reasonTitle) {
      return '';
    }

    return this.isArabic()
      ? `تم حذف سبب الرفض '${reasonTitle}' بنجاح`
      : `Rejection reason '${reasonTitle}' deleted successfully`;
  });
  onActionTrigger(event: { event: Event; actionId: number; entity: any }) {
    console.log('ACTION:', event);
    if (event.actionId === 4) {
      this.router.navigate(['/admin/cities/view-city-details', event.entity.id]);
      return;
    }

    if (event.actionId === 3) {
      this.router.navigate(['/admin/regions', event.entity.id]);
      return;
    }

    if (event.actionId === 1) {
      this.router.navigate(['/admin/cities/edit-city', event.entity.id], {
        state: {
          id: event.entity.id,
          titleAr: event.entity.titleAr,
          titleEn: event.entity.titleEn,
          governorateId: event.entity.governorateId ?? Number(this.governorateId()),
        },
      });

      return;
    }
    if (event.actionId === 2) {
      // this.selectedReasonId.set(event.entity.id);
      // this.selectedReasonTitle.set(event.entity.title);
      // this.deleteErrorMessage.set('');
      // this.showDeleteDialog.set(true);
      this.openDeleteConfirmation(event.entity.id);
    }
  }
  lastUpdatedOnFrom = signal<string | null>(null);
  lastUpdatedOnTo = signal<string | null>(null);
  fromDate = signal<string | null>(null);
  toDate = signal<string | null>(null);

  isArabic = computed(() => this.locale.startsWith('ar'));

  searchTerm = signal('');
  orderBy = signal<'TITLE' | 'CREATION_DATE' | 'LAST_MODIFICATION_DATE'>('CREATION_DATE');
  filters = signal({
    orderDir: 'DESC' as 'ASC' | 'DESC',
  });
  sortOptions = signal([
    {
      value: 'TITLE',
      labelEn: 'Title',
      labelAr: 'العنوان',
    },
    {
      value: 'CREATION_DATE',
      labelEn: 'Created Date',
      labelAr: 'تاريخ الإنشاء',
    },
    {
      value: 'LAST_MODIFICATION_DATE',
      labelEn: 'Last Modified Date',
      labelAr: 'آخر تعديل',
    },
  ]);
  loading = signal(false);
  errorGettingRejectionReasons = signal<string | null>(null);
  headerItems = computed(() => [
    { key: 'rowNumber', label: '#' },
    {
      key: 'title',
      label: this.isArabic() ? 'العنوان' : 'Title',
    },
    {
      key: 'number',
      label: this.isArabic() ? 'عدد المناطق' : 'Number of Regions',
    },
    {
      key: 'createdOnBy',
      label: this.isArabic() ? 'تاريخ الإنشاء / بواسطة' : 'Created On / By',
    },
    {
      key: 'lastModifiedOnBy',
      label: this.isArabic() ? 'آخر تعديل / بواسطة' : 'Last Modified On / By',
    },
    {
      key: 'actions',
      label: '',
      type: 'actions',
    },
  ]);
  rows = signal<Record<string, any>[]>([]);
  emptyStateMessage = computed(() => {
    if (this.searchTerm().trim()) {
      return this.isArabic() ? 'لا توجد مدن تطابق بحثك' : 'No cities match your search';
    }

    const hasFilters =
      this.fromDate() !== null ||
      this.toDate() !== null ||
      this.lastUpdatedOnFrom() !== null ||
      this.lastUpdatedOnTo() !== null;

    if (hasFilters) {
      return this.isArabic() ? 'لا توجد مدن تطابق الفلاتر المحددة' : 'No cities match your selected filters';
    }

    return this.isArabic() ? 'لا توجد مدن ' : 'No cities found';
  });
  loadCities() {
    this.loading.set(true);
    this.errorGettingRejectionReasons.set(null);
    const subscription = this.cityService
      .getAllCities(this.isArabic() ? 'ar' : 'en', {
        governorateId: this.governorateId(),
        pageNum: this.currentPage() - 1,
        pageSize: this.itemsPerPage(),
        orderBy: this.orderBy(),
        orderDir: this.filters().orderDir,
        quickSearch: this.searchTerm() || undefined,
        createdOnFrom: this.fromDate() || undefined,
        createdOnTo: this.toDate() || undefined,
        lastModifiedOnFrom: this.lastUpdatedOnFrom() || undefined,
        lastModifiedOnTo: this.lastUpdatedOnTo() || undefined,
      })
      .pipe(
        finalize(() => {
          this.loading.set(false);
        }),
      )
      .subscribe({
        next: (res: any) => {
          const list = res.list.map((item: any, index: any) => ({
            ...item,
            rowNumber: index + 1,
            title: this.isArabic() ? item.titleAr : item.titleEn,
            createdBy: item.createdBy?.fullName ?? '-',
            lastModifiedBy: item.lastModifiedBy?.fullName ?? '-',

            noOfRegions: item.noOfRegions,
          }));

          this.rows.set(list);
          this.totalItems.set(res.total);
        },
        error: (error) => {
          this.errorGettingRejectionReasons.set(
            this.isArabic()
              ? error.messageAr || 'حدث خطأ أثناء تحميل المدن'
              : error.messageEn || 'Error loading cities.',
          );
        },
      });
    this.destroyRef.onDestroy(() => subscription.unsubscribe());
  }

  actions = signal([
    {
      id: 4,
      titleEn: 'View City Details',
      titleAr: 'عرض تفاصيل المدينة',
    },
    {
      id: 3,
      titleEn: 'View Regions',
      titleAr: 'عرض المناطق',
    },
    {
      id: 1,
      titleEn: 'Edit City',
      titleAr: 'تعديل المدينة',
    },
    {
      id: 2,
      titleEn: 'Delete City',
      titleAr: 'حذف المدينة',
    },
  ]);
  currentPage = signal(1);
  itemsPerPage = signal(10);

  totalItems = signal(0);

  totalPages = computed(() => Math.ceil(this.totalItems() / this.itemsPerPage()));

  startItem = computed(() => (this.totalItems() === 0 ? 0 : (this.currentPage() - 1) * this.itemsPerPage() + 1));

  endItem = computed(() => Math.min(this.currentPage() * this.itemsPerPage(), this.totalItems()));

  pageNumbers = computed(() => Array.from({ length: this.totalPages() }, (_, index) => index + 1));
  onApplyFilters() {
    this.currentPage.set(1);
    this.loadCities();
  }
  onResetFilters() {
    this.searchTerm.set('');
    this.fromDate.set(null);
    this.toDate.set(null);
    this.lastUpdatedOnFrom.set(null);
    this.lastUpdatedOnTo.set(null);

    this.orderBy.set('CREATION_DATE');

    this.filters.set({
      orderDir: 'DESC',
    });

    this.currentPage.set(1);

    this.loadCities();
  }
  onGoToPage(page: number) {
    this.currentPage.set(page);
    this.loadCities();
  }

  onNextPage() {
    if (this.currentPage() < this.totalPages()) {
      this.currentPage.update((page) => page + 1);
      this.loadCities();
    }
  }

  onPreviousPage() {
    if (this.currentPage() > 1) {
      this.currentPage.update((page) => page - 1);
      this.loadCities();
    }
  }

  toggleSortOrder() {
    this.filters.update((filters) => ({
      ...filters,
      orderDir: filters.orderDir === 'ASC' ? 'DESC' : 'ASC',
    }));

    this.currentPage.set(1);
    this.loadCities();
  }

  //delete
  showDeleteConfirmation = signal(false);

  deleteCityTarget = signal<any | null>(null);

  successMessage = signal<string | null>(null);

  deleteTitle = $localize`:@@cityDeleteTitle:Delete City`;

  deleteDescription = $localize`:@@cityDeleteConfirmation:Are you sure you want to delete this city?`;

  deleteButton = signal($localize`:@@delete:Delete`);

  cancelButton = $localize`:@@cancelBtn:Cancel`;

  Loading = $localize`:@@loading:Loading...`;

  deleteError = signal('');

  openDeleteConfirmation(id: number) {
    this.deleteError.set('');
    const city = this.rows().find((row) => row['id'] === id);
    if (!city) {
      return;
    }

    this.deleteCityTarget.set(city);
    this.showDeleteConfirmation.set(true);
  }
  confirmDelete() {
    const city = this.deleteCityTarget();

    if (!city) {
      return;
    }
    this.deleteButton.set(this.Loading);

    const subscription = this.cityService.deleteCity(city.id).subscribe({
      next: () => {
        this.deleteButton.set($localize`:@@delete:Delete`);

        this.rows.update((rows) =>
          rows
            .filter((row) => row['id'] !== city.id)
            .map((row, index) => ({
              ...row,
              rowNumber: (this.currentPage() - 1) * this.itemsPerPage() + index + 1,
            })),
        );

        this.totalItems.update((total) => Math.max(0, total - 1));

        const cityName = this.isArabic() ? city.titleAr : city.titleEn;

        this.successMessage.set(
          this.isArabic() ? `تم حذف المدينة "${cityName}" بنجاح` : `City "${cityName}" deleted successfully`,
        );

        this.showDeleteConfirmation.set(false);
        this.deleteCityTarget.set(null);
        this.deleteError.set('');

        setTimeout(() => {
          this.successMessage.set(null);
        }, 3000);
      },

      error: (error) => {
        this.deleteButton.set($localize`:@@delete:Delete`);

        this.deleteError.set(
          this.isArabic()
            ? error?.messageAr || 'حدث خطأ أثناء حذف المدينة.'
            : error?.messageEn || 'Something went wrong while deleting the city.',
        );
      },
    });

    this.destroyRef.onDestroy(() => subscription.unsubscribe());
  }

  closeDeleteConfirmation() {
    this.showDeleteConfirmation.set(false);
    this.deleteCityTarget.set(null);
    this.deleteError.set('');
    this.deleteButton.set($localize`:@@delete:Delete`);
  }
}
